import { Component, OnInit,NgZone,ChangeDetectorRef,Input,Output,EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Component({
    selector: 'app-tagselect',
    templateUrl: './tagselect.component.html',
    styleUrls: ['./tagselect.component.css']
})
export class TagselectComponent implements OnInit {

    tag_list_type = [];
    groupTaglist = [];
    valuetag = [];
    tool_obj:any={tag:'-2'};
    oriNum = 0;


    constructor(public httpClient: HttpClient,private ngZone: NgZone,private cdr: ChangeDetectorRef,) {}

    ngOnInit(): void {
        this.init_list();
    }

    @Output() item = new EventEmitter<any>();
    @Input()  groupTagArr: any = []; 


   
    init_list(){
        const body = {};
        this.httpClient.post<any>("/tag_list.php",body).subscribe(res => {
            this.tag_list_type = res.groupTaglist.top;
            this.groupTaglist = res.groupTaglist.bottom;
            this.valuetag = res.groupTaglist.valuetag;
        });
    }

      
    showdeType(num){

        if(this.groupTagArr[num] != null){
            this.tool_obj.groupTag  = this.groupTagArr[num];
        }
    
    }

    showType(num){

        if(this.groupTagArr.length == 0){ //一開始第一個值
    
            this.groupTagArr[num] = this.tool_obj.groupTag;
        }
    
        if(num == this.oriNum){ 
    
            if(this.tool_obj.groupTag.length <  this.groupTagArr[num].length){
    
                this.groupTagArr[num] =  this.groupTagArr[num].filter(item => this.tool_obj.groupTag.includes(item));
    
            }else{
    
                this.tool_obj.groupTag.forEach(item => {
                   
                    if (!this.groupTagArr[num].includes(item)) {
                        this.groupTagArr[num].push(item);
                    }
    
                });
    
            }
            
           
        }else{ //新類型第一個值
    
            this.groupTagArr[num] = this.tool_obj.groupTag;
        }
       
        this.oriNum = num;


        this.item.emit(this.groupTagArr);

    
    }

    clearbtn(item,idx,index){
   
        this.groupTagArr[idx].splice(index, 1);
       
        if(this.tool_obj.groupTag.includes(item)){
            const index = this.tool_obj.groupTag.indexOf(item);
            this.ngZone.run(() => {
                this.tool_obj.groupTag.splice(index, 1);
                this.tool_obj.groupTag = [...this.tool_obj.groupTag];
                this.cdr.detectChanges(); // 或者使用 this.cdr.markForCheck();
            });
        }
        
      }






}
